import {
    AddressToFollowEntity,
    DelegationEntity,
    FundEntity,
    FundHoldingEntity,
    InvestUnitEntity,
    ProtocolEntity,
    ScriptEntity,
    SwapOfferEntity,
} from '@/src/lib/MayzSmartDB/Entities/index';
import { AddressToFollowApi } from '@/src/lib/MayzSmartDB/index';
import { useAppStore } from '@/src/store/global';
import { UTxO } from '@lucid-evolution/lucid';
import { useEffect, useState } from 'react';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 300,
    padding: '15px',
    borderRadius: '15px',
    bgcolor: `#e2a7a7`,
    backdropFilter: 'blur(12px)',
};

export const useModalDatum = ({ uTxO }: { uTxO: UTxO }) => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const [datumType, setDatumType] = useState<string>();
    const [datumObject, setDatumObject] = useState<any>(undefined);
    //--------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);
    //--------------------------------------
    useEffect(() => {
        const fetchData = async () => {
            if (uTxO.datum !== undefined && uTxO.datum !== null) {
                let datum = undefined;
                const addressesToFollow: AddressToFollowEntity[] = await AddressToFollowApi.getByParamsApi_({ address: uTxO.address });
                const possibleDatums: string[] = [];
                addressesToFollow.forEach((addressToFollow) => possibleDatums.push(addressToFollow.datumType));
                possibleDatums.forEach((datumType) => {
                    if (uTxO.datum !== undefined && uTxO.datum !== null) {
                        if (datumType === ProtocolEntity.className()) {
                            try {
                                datum = ProtocolEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(ProtocolEntity.className());
                            } catch (error) {}
                            return;
                        } else if (datumType === FundEntity.className()) {
                            try {
                                datum = FundEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(FundEntity.className());
                            } catch (error) {}
                        } else if (datumType === ScriptEntity.className()) {
                            try {
                                datum = ScriptEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(ScriptEntity.className());
                            } catch (error) {}
                        } else if (datumType === InvestUnitEntity.className()) {
                            try {
                                datum = InvestUnitEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(InvestUnitEntity.className());
                            } catch (error) {}
                        } else if (datumType === FundHoldingEntity.className()) {
                            try {
                                datum = FundHoldingEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(FundHoldingEntity.className());
                            } catch (error) {}
                        } else if (datumType === SwapOfferEntity.className()) {
                            try {
                                datum = SwapOfferEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(SwapOfferEntity.className());
                            } catch (error) {}
                        } else if (datumType === DelegationEntity.className()) {
                            try {
                                datum = DelegationEntity.mkDatumFromDatumCborHex(uTxO.datum);
                                setDatumType(DelegationEntity.className());
                            } catch (error) {}
                        }
                    }
                });
                if (datum !== undefined) {
                    setDatumObject(datum);
                }
            }
        };
        fetchData();
    }, []);
    //--------------------------------------
    return {
        appStore,
        isRefreshing,
        datumType,
        datumObject,
        isOpen,
        handleOpen,
        handleClose,
    };
    //--------------------------------------
};
